<div
  class="cursor-row"
  #cursor
  [style.width.px]="this.cellSize"
  [style.height.px]="this.cellSize"
></div>
